import React, {useEffect, useRef, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'
import {getImageBaseUrl} from '../../../../../../utils/Utils'

const VerificationSystemPlugin = () => {
  const hiddenFileInput = useRef<HTMLInputElement>(document.createElement('input'))

  const [configID, setConfigId] = useState(0)
  const [isImageUploaded, setisImageUploaded] = useState<any>(false)
  const [file, setFile] = useState('')
  const [verificationSystemConfig, setVerificationSystemConfig] = useState<any>({
    isEnable: true,
    isNudityDetectorEnabled: false,
    pornPercentage: 80,
    hentaiPercentage: 80,
    sexyPercentage: 80,
    neutralPercentage: 80,
    drawingPercentage: 80,
    gestureImage: '',
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = async (event: any) => {
    let name = event.target.name
    let type = event.target.type
    let value = type === 'checkbox' ? event.target.checked : event.target.value

    if (name === 'isEnable' && !value) {
      // check if any of the other plugins have verified only features enabled
      let videocallResult = await getConfigurationByName('videocall')
      let audiochatResult = await getConfigurationByName('audiochat')
      let randomcallResult = await getConfigurationByName('random-audio-video-call')

      let isVideocallVerifiedOn = false;
      let isAudiochatVerifiedOn = false;
      let isRandomAudioVerifiedOn = false;
      let isRandomVideoVerifiedOn = false;

      if (videocallResult.success && videocallResult.data) {
        let parsed = JSON.parse(videocallResult.data.values)
        isVideocallVerifiedOn = parsed.verifiedUserOnlyCreate
      }
      if (audiochatResult.success && audiochatResult.data) {
        let parsed = JSON.parse(audiochatResult.data.values)
        isAudiochatVerifiedOn = parsed.verifiedUserOnlyCreate
      }
      if (randomcallResult.success && randomcallResult.data) {
        let parsed = JSON.parse(randomcallResult.data.values)
        isRandomAudioVerifiedOn = parsed.verifiedUserOnlyRandomAudioCall
        isRandomVideoVerifiedOn = parsed.verifiedUserOnlyRandomVideoCall
      }

      if (isVideocallVerifiedOn || isAudiochatVerifiedOn || isRandomAudioVerifiedOn || isRandomVideoVerifiedOn) {
        let pluginName = isVideocallVerifiedOn ? 'Videocall' : (isAudiochatVerifiedOn ? 'Audiochat' : 'Random Audio/Video call')
        ToastUtils({
          type: 'error',
          message: `In ${pluginName} plugin your verification setting is on. Turn it off first, then you can disable it here.`
        })
        return
      }
    }

    if (type === 'number') {
      setVerificationSystemConfig({...verificationSystemConfig, gestureImage: file, [name]: Number(value)})
    } else {
      setVerificationSystemConfig({...verificationSystemConfig, gestureImage: file, [name]: value})
      updateConfiguration({...verificationSystemConfig, gestureImage: file, [name]: value}, null)
    }
  }

  const onBlurUpdate = () => {
    updateConfiguration({...verificationSystemConfig, gestureImage: file}, null)
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('verification')
    if (result.success) {
      let parsedData = JSON.parse(result.data.values)
      setConfigId(result.data.id)
      setVerificationSystemConfig({
        isEnable: parsedData.isEnable,
        isNudityDetectorEnabled: parsedData.isNudityDetectorEnabled ?? false,
        pornPercentage: parsedData.pornPercentage ?? 80,
        hentaiPercentage: parsedData.hentaiPercentage ?? 80,
        sexyPercentage: parsedData.sexyPercentage ?? 80,
        neutralPercentage: parsedData.neutralPercentage ?? 80,
        drawingPercentage: parsedData.drawingPercentage ?? 80,
      })
      setFile(parsedData.gestureImage)
    }
  }

  const updateConfiguration = async (config: any, fileUploaded: any) => {
    let result = await updateConfigurationByConfigID(configID, config, fileUploaded)

    if (result.success) {
      getConfiguration()
      setisImageUploaded(false)
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  const handleIconChange = (event: any) => {
    setisImageUploaded(true)
    const fileUploaded = event.target.files[0]
    //setFile(fileUploaded)
    updateConfiguration({...verificationSystemConfig}, fileUploaded)
  }

  const handleClick = () => {
    const fileInput = document.getElementById(`fileInput`)
    fileInput?.click()
  }

  let baseImageUrl = getImageBaseUrl()

  return (
    <div className='card'>
      <div className='card-title p-8'>
        <h2>Verification System settings</h2>
      </div>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Profile verification</strong>
            </p>
            <p className='text-muted'>
              If enabled allow users to upload a photo coping a gesture to get manually verified by
              admin or moderator
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isEnable'
                checked={verificationSystemConfig.isEnable}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Gesture image as example</strong>
            </p>
            <p className='text-muted'>Upload gesture example image for photo verification</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <div className='symbol symbol-70px overflow-visible me-3'>
                <img
                  src={
                    `${baseImageUrl}/${file}` ||
                    `https://preview.keenthemes.com/metronic8/react/demo1//media/avatars/300-6.jpg`
                  }
                  alt='icon'
                  loading='lazy'
                />
                <button
                  className='ms-4 btn btn-primary'
                  onClick={() => {
                    handleClick()
                    setisImageUploaded(false)
                  }}
                >
                  Choose Gesture
                </button>

                <input
                  type='file'
                  name='icon'
                  id={`fileInput`}
                  onChange={(e) => handleIconChange(e)}
                  ref={hiddenFileInput}
                  style={{display: 'none'}} // Make the file input element invisible
                  accept='image/*'
                />
              </div>
            </div>
          </div>

          <div className='col-12 mt-8 mb-4'>
            <h3 className='headings-color border-bottom pb-2'>Nudity Content Detector Settings</h3>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Nudity Detector</strong>
            </p>
            <p className='text-muted'>
              Enable to automatically scan uploaded verification photos for explicit content using the nudity detection API.
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                name='isNudityDetectorEnabled'
                checked={verificationSystemConfig.isNudityDetectorEnabled}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Porn Percentage Threshold</strong>
            </p>
            <p className='text-muted'>
              If the detected pornographic content exceeds this percentage, the photo will be rejected. 
              Higher values mean looser restrictions.
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <label className='form-check-label mb-2'>Porn Threshold (%)</label>
              <input
                type='number'
                className='form-control'
                name='pornPercentage'
                value={verificationSystemConfig.pornPercentage}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
                disabled={!verificationSystemConfig.isNudityDetectorEnabled}
                min={0}
                max={100}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Hentai Percentage Threshold</strong>
            </p>
            <p className='text-muted'>
              If the detected hentai/animated explicit content exceeds this percentage, the photo will be rejected.
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <label className='form-check-label mb-2'>Hentai Threshold (%)</label>
              <input
                type='number'
                className='form-control'
                name='hentaiPercentage'
                value={verificationSystemConfig.hentaiPercentage}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
                disabled={!verificationSystemConfig.isNudityDetectorEnabled}
                min={0}
                max={100}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Sexy Percentage Threshold</strong>
            </p>
            <p className='text-muted'>
              If the detected sexually suggestive (sexy) content exceeds this percentage, the photo will be rejected.
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <label className='form-check-label mb-2'>Sexy Threshold (%)</label>
              <input
                type='number'
                className='form-control'
                name='sexyPercentage'
                value={verificationSystemConfig.sexyPercentage}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
                disabled={!verificationSystemConfig.isNudityDetectorEnabled}
                min={0}
                max={100}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Neutral Percentage Threshold</strong>
            </p>
            <p className='text-muted'>
              Minimum required percentage of neutral (safe) content. If neutral content is below this percentage, the photo may be rejected.
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <label className='form-check-label mb-2'>Neutral Threshold (%)</label>
              <input
                type='number'
                className='form-control'
                name='neutralPercentage'
                value={verificationSystemConfig.neutralPercentage}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
                disabled={!verificationSystemConfig.isNudityDetectorEnabled}
                min={0}
                max={100}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Drawing Percentage Threshold</strong>
            </p>
            <p className='text-muted'>
              If the detected content is recognized as a drawing or illustration and exceeds this percentage, the photo may be rejected.
            </p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <label className='form-check-label mb-2'>Drawing Threshold (%)</label>
              <input
                type='number'
                className='form-control'
                name='drawingPercentage'
                value={verificationSystemConfig.drawingPercentage}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
                disabled={!verificationSystemConfig.isNudityDetectorEnabled}
                min={0}
                max={100}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default VerificationSystemPlugin
